import { useNavigate } from 'react-router-dom'
import ConfigIcon from '../../../icons/ConfigIcon'
import LogOutIcon from '../../../icons/LogOutIcon'
import { logOut } from '../../../services/user'
import Divider from '../../Divider'
import SidebarButton from './SidebarButton'
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from '../../../Routes/routes'
import { reloadPage } from '../../../utils'
import CustomModal from '../../Modals/CustomModal'
import LogOutTwoIcon from '../../../icons/LogOutTwoIcon'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next'
import { LOCAL_STORAGE_VALUES, hasDevelopmentFeatures, idiom } from '../../../localStorage'
import { IS_ADMIN, IS_RECRUITER, LIST_OF_IDIOMS, VIEWPORT_LG } from '../../../utils/constants'
import NoteIcon from '../../../icons/NoteIcon'
import FiltersIcon from '../../../icons/FiltersIcon'
import WindowQuestionIcon from '../../../icons/WindowQuestionIcon'
import useResize from '../../../hooks/useResize'
import TranslateIcon from '../../../icons/TranslateIcon'
import SpainIcon from '../../../icons/idioms/SpainIcon'
import EnglishIcon from '../../../icons/idioms/EnglishIcon'

const Footer = ({ setOpenDrawer }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG
  const handleCloseDrawer = () => {
    if(!isMobile) return
    setOpenDrawer(false)
  }

  const handleLogOut = () => {
    CustomModal({
      Image: () => <LogOutTwoIcon />,
      title: t('youre_about_to_leave'),
      description: t('are_you_sure_you_want_to_log_out'),
      textPrimaryButton: t('log_out'),
      textSecondaryButton: t('cancel'),
      handlePrimaryButton: async () => {
        await localStorage.setItem(
          LOCAL_STORAGE_VALUES.skip_linkedin_modal,
          false
        )
        await Swal.close()
        await logOut()
        await reloadPage()
        window.location.href = PUBLIC_ROUTES.login
      },
      handleSecondaryButton: () => Swal.close(),
    })
  }

  const handleGoToConfig = () => {
    navigate(PRIVATE_ROUTES.setting)
  }

  const handleChangeIdiom = ({ idiom = 'es' }) => {
    localStorage.setItem(LOCAL_STORAGE_VALUES.idiom, JSON.stringify(idiom))
    reloadPage()
  }

  return (
    <div
      id="sidebar-footer"
      className=" d-flex flex-column justify-content-start align-items-start ps-3 mb-2"
    >
      {IS_RECRUITER && (
        <SidebarButton
          Icon={() => <WindowQuestionIcon />}
          title={t('frequent_questions')}
          className="text-white"
          onClick={() => {
            handleCloseDrawer()
            navigate(PRIVATE_ROUTES.frecuent_questions)
          }}
        />
      )}
      {IS_ADMIN && hasDevelopmentFeatures && (
        <SidebarButton
          Icon={() => <ConfigIcon />}
          title="Tipos de formularios"
          className="text-white"
          onClick={() => {
            handleCloseDrawer()
            navigate(PRIVATE_ROUTES.form_types)
          }}
        />
      )}
      {IS_ADMIN && hasDevelopmentFeatures && (
        <SidebarButton
          Icon={() => <FiltersIcon />}
          title="Flags de registro"
          className="text-white"
          onClick={() => {
            handleCloseDrawer()
            navigate(PRIVATE_ROUTES.register_flags)
          }}
        />
      )}
      <div className="dropup">
        <SidebarButton
          Icon={() => <TranslateIcon width="16" height="16" fill="#E4F8ED" />}
          title={t('change_idiom')}
          className="text-white"
          data-bs-toggle="dropdown"
          role="button"
        />
        <ul
          className="dropdown-menu font-extra-small"
        >
          <li>
            <button
              className="dropdown-item d-flex align-items-center gap-2"
              style={idiom === LIST_OF_IDIOMS.spanish ? { backgroundColor: '#E4F8ED', color: '#01A76A', fontWeight: 600 } : {}}
              onClick={() => handleChangeIdiom({ idiom: LIST_OF_IDIOMS.spanish })}
            >
              <SpainIcon />
              <span>{t('spanish')}</span>
            </button>
          </li>
          <li>
            <button
              className="dropdown-item d-flex align-items-center gap-2"
              style={idiom === LIST_OF_IDIOMS.english ? { backgroundColor: '#E4F8ED', color: '#01A76A', fontWeight: 600 } : {}}
              onClick={() => handleChangeIdiom({ idiom: LIST_OF_IDIOMS.english })}
            >
              <EnglishIcon />
              <span>{t('english')}</span>
            </button>
          </li>
        </ul>
      </div>
      {IS_ADMIN && (
        <SidebarButton
          Icon={() => <NoteIcon fill="#E4F8ED" width="16" height="16" />}
          title="Contratos"
          className="text-white"
          onClick={() => {
            handleCloseDrawer()
            navigate(PRIVATE_ROUTES.master_contract_documents)
          }}
        />
      )}
      <SidebarButton
        Icon={() => <ConfigIcon />}
        title={t('setting')}
        className="text-white"
        onClick={() => {
          handleCloseDrawer()
          handleGoToConfig()
        }}
      />
      <Divider className="mt-1 mb-2 bg-on-bg-brand" />
      <SidebarButton
        Icon={() => <LogOutIcon className="log-out" />}
        title={t('log_out')}
        className="log-out"
        onClick={() => {
          handleCloseDrawer()
          handleLogOut()
        }}
      />
    </div>
  )
}

export default Footer
